import { render } from "./ApplicationTabComponent.vue?vue&type=template&id=5d45fe6c&ts=true"
import script from "./ApplicationTabComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationTabComponent.vue?vue&type=script&lang=ts"

import "./ApplicationTabComponent.vue?vue&type=style&index=0&id=5d45fe6c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__